import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import AdminAPI from "../../api/admin";
import { AttendanceUserDto } from "../../api/admin/attendance";
import AttendancePage from "../../components/table/AttendancePaging";
import InputFormStyle from "../../components/style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import CafePagingTable from "../../components/table/CafePagingTable";
import { Header } from "../../components/table/interface/interface";
import ButtonStyle from "../../components/style/button.component";
import { loadingState } from "../../recoil/loading.atom";
import { useSetRecoilState } from "recoil";
import DateForm from "../../components/form/form_date";

const AttendanceHistory = () => {
  const [dataList, setDataList] = useState<AttendanceUserDto[]>([]);
  const setLoading = useSetRecoilState(loadingState);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [keyword, setKeyWord] = useState("");
  const limit = 10;
  const headers = [
    { text: "닉네임", align: "center", sortable: false, value: "nickname" },
    { text: "수령일", align: "center", sortable: false, value: "createdAt" },
    { text: "수령 GP", align: "center", sortable: false, value: "value" },
  ];
  function formatDate(dateString: string) {
    if (!dateString) {
      return "Invalid Date";
    }

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const handleSearch = async (search: string) => {
    setCurrentPage(1);

    const res = await AdminAPI.getAttendanceUser(currentPage, limit, search);
    if (res) {
      const updatedData = res.data.map((item: AttendanceUserDto) => ({
        ...item,
        createdAt: formatDate(item.createdAt),
      }));
      const totalPages = Math.ceil(res.total / limit);
      setTotalCount(res.total);
      setTotalPages(totalPages);
      setDataList(updatedData);
    }
  };

  const exportToExcel = async (headers: Header[]) => {
    setLoading(true);
    const today = new Date().toISOString().split("T")[0];
    try {
      if (!startDate || !endDate) {
        alert("엑셀 시작일과 종료일을 모두 설정해주세요.");
        setLoading(false);
        return;
      }

      // 응답을 Blob으로 직접 받기
      const blob = await AdminAPI.getAttendanceUserCSV(startDate, endDate);

      // Blob 객체 확인
      if (!(blob instanceof Blob)) {
        throw new Error("서버에서 올바른 데이터 형식을 반환하지 않았습니다.");
      }
      // 파일 다운로드 처리
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `all_report_${today}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("다운로드 오류:", error);
      alert("다운로드 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };
  const getDatas = async () => {
    const res = await AdminAPI.getAttendanceUser(currentPage, limit, keyword);
    if (res) {
      const updatedData = res.data.map((item: AttendanceUserDto) => ({
        ...item,
        createdAt: formatDate(item.createdAt),
      }));
      const totalPages = Math.ceil(res.total / limit);
      setTotalCount(res.total);
      setTotalPages(totalPages);
      setDataList(updatedData);
    }
  };
  useEffect(() => {
    getDatas();
  }, []);
  return (
    <>
      <DivStyle
        style={{ overflow: "auto" }}
        backgroundColor="#121212"
        height="100vh"
        display="flex"
        flex_direction="column"
        align_items="center"
        marginTop="65px"
      >
        <h2 style={{ color: "white", width: "95%", marginTop: "40px" }}>
          출석 현황
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <DivStyle
            width="100%"
            display="flex"
            flex_direction="row"
            justify_content="flex-end"
            align_items="center"
          >
            <DivStyle
              width="50%"
              display="flex"
              justify_content="flex-end"
              flex_direction="row"
              align_items="center"
              marginRight="20px"
              marginTop="20px"
            >
              <DateForm
                value={startDate}
                label={"엑셀시작일"}
                setValue={setStartDate}
                width={"50%"}
              ></DateForm>
              <DateForm
                value={endDate}
                label={"엑셀종료일"}
                setValue={setEndDate}
                width={"50%"}
              ></DateForm>
              <ButtonStyle
                onClick={() => exportToExcel(headers)}
                backgroundColor="#ffffff"
                color="#000000"
                width="100px"
                borderRadius="10px"
              >
                엑셀
              </ButtonStyle>
              <InputFormStyle
                width="200px"
                onChange={(e) => {
                  setKeyWord(e.target.value);
                  handleSearch(e.target.value);
                }}
              ></InputFormStyle>
              <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
            </DivStyle>
          </DivStyle>

          <CafePagingTable
            headers={headers}
            currentPage={currentPage}
            dataList={dataList}
            size={limit}
          />
          <AttendancePage
            count={totalCount}
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={dataList}
            setDataList={setDataList}
            setCurrentPage={setCurrentPage}
            search={keyword}
          />
        </DivStyle>
      </DivStyle>
    </>
  );
};

export default AttendanceHistory;
